// src/components/ProductReviews.js
import React from "react";
import { Box, Link } from "@mui/material";

const ProductReviews = () => {
  const homepageUrl = "https://www.alphabetsigns.com";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mr: 2, // Margin-right for spacing
      }}
    >
      <Link href={homepageUrl} underline="none">
        <img
          src="https://www.alphabetsigns.com/mm5/graphics/00000002/23071-standard_large.gif"
          alt="product reviews logo"
          style={{
            height: "40px", // Match toolbar height
            width: "auto",
            objectFit: "contain",
          }}
        />
      </Link>
    </Box>
  );
};

export default ProductReviews;
